import React, { useState, useEffect } from 'react';
import { FaLightbulb } from 'react-icons/fa';
import axios from 'axios';
import '../styles/Recommendations.css';

const API = process.env.REACT_APP_API_URL || '';

function Recommendations({ albumId, onAlbumClick }) {
  const [recommendations, setRecommendations] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (albumId) loadRecommendations();
  }, [albumId]);

  const loadRecommendations = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/api/recommendations/album/${albumId}`);
      setRecommendations(res.data);
    } catch (e) { /* ignore */ }
    finally { setLoading(false); }
  };

  if (!recommendations.length && !loading) return null;

  const sourceLabels = {
    collection: 'Même collection',
    tags: 'Ambiance similaire',
    collaborative: 'Les auditeurs aiment aussi',
    artist: 'Même artiste',
    category: 'Même catégorie'
  };

  return (
    <div className="recommendations">
      <h3><FaLightbulb /> Si vous aimez cet album...</h3>
      {loading ? (
        <div className="reco-loading">Chargement...</div>
      ) : (
        <div className="reco-grid">
          {recommendations.map(r => (
            <div key={r.id} className="reco-card" onClick={() => onAlbumClick && onAlbumClick(r)}>
              <img src={r.cover_url ? (r.cover_url.startsWith('http') ? r.cover_url : `${API}${r.cover_url}`) : '/logo192.png'} alt="" />
              <div className="reco-info">
                <div className="reco-title">{r.title}</div>
                <div className="reco-artist">{r.artist}</div>
                <div className="reco-source">{sourceLabels[r.source] || ''}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Recommendations;
